import { render, staticRenderFns } from "./orderFormByChannel3.vue?vue&type=template&id=5b1c84d0&scoped=true"
import script from "./orderFormByChannel3.vue?vue&type=script&lang=js"
export * from "./orderFormByChannel3.vue?vue&type=script&lang=js"
import style0 from "./orderFormByChannel3.vue?vue&type=style&index=0&id=5b1c84d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c84d0",
  null
  
)

export default component.exports